import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const BatchChildWorkflowSchema_ = z.object({
  workflowId: z.string(),
  status: z.enum(["running", "completed", "failed", "unknown"]),
  startTime: z.string().nullable(),
});
export interface BatchChildWorkflowSchema
  extends z.infer<typeof BatchChildWorkflowSchema_> {}
export const BatchChildWorkflowSchema: z.ZodType<BatchChildWorkflowSchema> =
  BatchChildWorkflowSchema_;

const BatchOnboardingInfoSchema_ = z.object({
  workflowId: z.string(),
  status: z.enum(["running", "completed", "failed", "unknown"]),
  startTime: z.string().nullable(),
  children: z.array(BatchChildWorkflowSchema),
});
export interface BatchOnboardingInfoSchema
  extends z.infer<typeof BatchOnboardingInfoSchema_> {}
export const BatchOnboardingInfoSchema: z.ZodType<BatchOnboardingInfoSchema> =
  BatchOnboardingInfoSchema_;

export const getBatchOnboardingStatus = unaryRpc({
  name: "getBatchOnboardingStatus",
  input: z.object({}),
  output: z.object({ batches: z.array(BatchOnboardingInfoSchema) }),
});
